<template>
  <div>
    <div v-if="showBack" class="robot-header fx">
      <el-button @click="dispatch('robot', 'activeIndexChange', 0)" icon="el-icon-arrow-left" type="text" size="mini">返回</el-button>
    </div>
    <!-- <div v-show="!subscribeInfo.length" class="loadingBox" style="padding-top:94px;padding-bottom:240px">
      <img src="@/assets/newicons/ib02.png" class="icon360" style="width:24px;height:24px" alt="" srcset="">
    </div> -->
    <div v-show="!subscribeInfo.length" class="xtNoData">
      <img src="@/assets/subscribe/empty.png">
      <p>暂无消息</p>
    </div>
    <ul class="someCompany">
      <li v-for="item in subscribeInfo" :key='item.id'>
        <p class="companyName" :title="item.content">{{item.content}}</p>
        <p class="tips">{{item.pushTime}}</p>
      </li>
    </ul>
    <div :class="['btns',{'btnsHidden':!subscribeInfo.length}]">
       <el-button style="margin-left:20px" type="dialog-confirm" w100 @click="toPage">查看订阅</el-button>
      
    </div>

  </div>
</template>

<script>
import emitter from '@/mixins/emitter'
import { recommendList, batchStar, contactList, contactCount } from '../api/newClueApi'

import {subscribemessages,updateReadStatus} from '@/views/clue/api/subscribeApi'

export default {
  name: 'robotView3',
  components: {
  },
  mixins: [emitter],
  props: {
    showBack: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false,
      subscribeInfo:[]
    }
  },
  mounted () {
    this.getSubscribemessages()
  },
  methods: {
      
   async getSubscribemessages(){
       const res = await subscribemessages()
        if(res.code == 200){
           this.subscribeInfo = res.data
           let ids = []
           res.data.forEach(e => {
             if(e.isRead == 0){
                ids.push(e.id)
             }
           });
           updateReadStatus({ids:ids}).then(res =>{
               if(res.code == 200){
                 
               }
           })
        }
      },


    toPage () {
      if (this.$route.path === '/zxk/junbros/subscribeList') {
        this.$router.go(0)
      } else {
        this.$router.push({ path: '/zxk/junbros/subscribeList' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.robot-header {
  position: absolute;
  top: 6px;
  left: 16px;
  .el-button {
    color: #fff;
  }
}
/deep/ {
  .robot-header {

  .el-button {
    color: #666666;
    display: flex;
    align-items: center;
    font-size: 12px;
    i{
      font-size: 13px;
    }
    span{
      font-size: 12px;
    }
  }
}
}
h5 {
  text-align: center;
  line-height: 48px;
  font-weight: 400;
  margin-top: 18px;
}
.loadingBox {
  text-align: center;
  > img {
    width: 100%;
  }
}

.someCompany {
border-radius: 8px;
// margin-top: 15px;
margin-top: 31px;

  // li + li {
  //   border-top: 1px solid rgba(52, 57, 81, 0.05);
  // }
  li {
    // padding: 20px;
    padding: 16px 0;
    padding-bottom: 5;
    border-bottom: 1px solid rgba(52, 57, 81, 0.05);
    p {
      line-height: 17px;
    }
    .companyName {
      line-height: 20px;
      margin-bottom: 2px;
      cursor: pointer;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      font-size: 14px;
      font-weight: 600;
      color: #666666;
    }
    .tips {
      font-size: 12px;
      color: #999999;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}

.btns {
  display: flex;
  justify-content: center;
  padding-top: 24px;
  &.btnsHidden {
    visibility: hidden;
  }
  > div {
    cursor: pointer;
    padding: 10px 20px;
    margin: 10px;
    background-color: #2e313d;
    border-radius: 7px;
    &:hover {
      // color: wheat;
    }
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
      }

    .btn01{
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 2px 4px 0px #EDEEF3;
    border-radius: 4px;
    border: 1px solid #BBBECA;
    }
    .btn02{
    background: #5088FF;
    box-shadow: 0px 6px 10px 0px rgba(80, 136, 255, 0.2);
    border-radius: 4px;
    color: #ffffff;
    }

}
.xtNoData{
  text-align: center;
  img{
    width: 150px;
    margin-top: 30px;
  }
  p{
    color: #999999;
  }
}



</style>
